// O navegador só deixa abrir aba até ~5s depois do clique: a aba abre no clique e recebe o PDF quando ele chegar
export const openPendingTab = () => {
    const win = window.open('', '_blank');
    if (win) {
        win.document.title = 'Gerando documento...';
        win.document.body.innerHTML = '<p style="font-family: sans-serif; margin: 2rem;">Gerando documento...</p>';
    }
    return win;
};

const dataUrlToBlobUrl = dataUrl => {
    const [header, base64] = dataUrl.split(',');
    const mime = header.match(/^data:([^;]+)/)?.[1] || 'application/pdf';
    const binary = window.atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return URL.createObjectURL(new Blob([bytes], {type: mime}));
};

// Blob URL em vez de data URL: o Chrome não abre data URL na aba e o PDF grande estoura o limite da URL
export const showPdfInTab = (win, dataUrl) => {
    // O backend responde 200 com JSON de aviso quando não há documento
    if (typeof dataUrl !== 'string' || !dataUrl.startsWith('data:')) {
        closePendingTab(win);
        return false;
    }
    const url = dataUrlToBlobUrl(dataUrl);
    if (win && !win.closed) {
        win.location.href = url;
    } else {
        window.open(url, '_blank');
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    return true;
};

export const closePendingTab = win => {
    if (win && !win.closed) {
        win.close();
    }
};
